module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/main/main.component.scss
// module id = ./src/app/pages/main/main.component.scss
// module chunks = main